"use strict";

require("core-js/modules/web.dom.iterable");

require("core-js/modules/es6.array.iterator");

require("core-js/modules/es6.object.to-string");

require("core-js/modules/es6.object.keys");

require("core-js/modules/es6.array.index-of");

require("core-js/modules/es6.symbol");

require("core-js/modules/es6.object.assign");

require("core-js/modules/es6.object.define-property");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _styledComponents = require("./styled-components");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

var Heading = function Heading(_ref) {
  var _ref$variant = _ref.variant,
      variant = _ref$variant === void 0 ? 'h1' : _ref$variant,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? 'dark' : _ref$color,
      children = _ref.children,
      props = _objectWithoutProperties(_ref, ["variant", "color", "children"]);

  switch (variant) {
    case 'h1':
      return /*#__PURE__*/_react["default"].createElement(_styledComponents.StyledH1, _extends({}, props, {
        color: color
      }), children);

    case 'h2':
      return /*#__PURE__*/_react["default"].createElement(_styledComponents.StyledH2, _extends({}, props, {
        color: color
      }), children);

    case 'h3':
      return /*#__PURE__*/_react["default"].createElement(_styledComponents.StyledH3, _extends({}, props, {
        color: color
      }), children);

    case 'h4':
      return /*#__PURE__*/_react["default"].createElement(_styledComponents.StyledH4, _extends({}, props, {
        color: color
      }), children);

    case 'h5':
      return /*#__PURE__*/_react["default"].createElement(_styledComponents.StyledH5, _extends({}, props, {
        color: color
      }), children);

    case 'h6':
      return /*#__PURE__*/_react["default"].createElement(_styledComponents.StyledH6, _extends({}, props, {
        color: color
      }), children);

    default:
      return /*#__PURE__*/_react["default"].createElement(_styledComponents.StyledH1, _extends({}, props, {
        color: color
      }), children);
  }
};

var _default = Heading;
exports["default"] = _default;